(function () {
  'use strict';

  const LOG = '[kg-atc-sync]';
  const Kg = window.KgPricing;
  if (!Kg) {
    console.warn(`${LOG} kg-pricing-core.js must load first`);
    return;
  }

  let currentSku = '';
  let currentVariantId = 0;
  let unsubscribeVariant = null;

  function readInitialSku() {
    const el = document.querySelector('kg-live-price');
    if (el && el.dataset && el.dataset.initialSku) {
      return el.dataset.initialSku.trim();
    }
    return '';
  }

  function readInitialVariantId() {
    const select = document.querySelector('select[name="id"]');
    if (select && select.value) return Number(select.value) || 0;
    const form = document.querySelector('product-form form');
    if (form) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput && idInput.value) return Number(idInput.value) || 0;
    }
    return 0;
  }

  function attachPubsub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    try {
      unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const v = event && event.data && event.data.variant;
        if (!v) return;
        currentSku = (v.sku || '').trim();
        currentVariantId = Number(v.id) || 0;
      });
    } catch (e) { /* swallow */ }
  }

  function setButtonPending(button, pending) {
    if (!button) return;
    if (pending) {
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('disabled', 'disabled');
      button.classList.add('kg-atc-pending');
    } else {
      button.removeAttribute('aria-busy');
      button.removeAttribute('disabled');
      button.classList.remove('kg-atc-pending');
    }
  }

  function findSubmitButton(form) {
    return form.querySelector('button[type="submit"], input[type="submit"]') || null;
  }

  function findProductForm(form) {
    return form.closest('product-form') || form.closest('form[action*="cart/add"]') || null;
  }

  async function onFormSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const inProductForm = !!form.closest('product-form');
    const isCartAdd = !!form.action && form.action.indexOf('/cart/add') !== -1;
    if (!inProductForm && !isCartAdd) return;

    if (form.dataset.kgAtcInFlight === '1') {
      delete form.dataset.kgAtcInFlight;
      return;
    }

    event.preventDefault();
    form.dataset.kgAtcInFlight = '1';

    const button = findSubmitButton(form);
    setButtonPending(button, true);

    const sku = currentSku || readInitialSku();
    let syncOk = true;
    if (sku) {
      try {
        const sync = await Kg.syncVariantPrice(sku);
        syncOk = !!(sync && sync.ok);
        if (!syncOk) console.warn(`${LOG} price sync not confirmed`, sync && sync.reason);
      } catch (e) {
        syncOk = false;
        console.warn(`${LOG} price sync failed`, e);
      }
    }

    setButtonPending(button, false);

    // The cart-poll checkout intercept re-verifies every line's price
    // before payment, so an add-to-cart sync miss here isn't a payment
    // risk by itself — but proceeding silently on a stale price is
    // exactly the bug we're fixing, so surface it and let the shopper
    // retry rather than add at an unconfirmed price.
    if (sku && !syncOk) {
      delete form.dataset.kgAtcInFlight;
      if (button) {
        button.classList.add('kg-atc-error');
        setTimeout(() => button.classList.remove('kg-atc-error'), 3000);
      }
      console.warn(`${LOG} add-to-cart blocked — could not confirm live price for ${sku}`);
      return;
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function install() {
    if (!document.addEventListener) return;
    document.addEventListener('submit', onFormSubmit, true);
  }

  function init() {
    currentSku = readInitialSku();
    currentVariantId = readInitialVariantId();
    attachPubsub();
    install();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
